import { useSyncExternalStore } from 'react';

/**
 * True below the single-column breakpoint — where the multi-pane layout folds
 * to one column and the rail becomes a bottom island.
 *
 * 768px is duplicated in the layout CSS media queries (ChatLayout, ChatRail,
 * ConversationHeader); this is the one JS mirror of that line, read where a
 * layout choice can't be expressed in CSS alone — namely whether opening the
 * app should land on the list or inside the newest chat (see ChatPage).
 */
// One MediaQueryList for the app, not one per render: the query is constant and
// the MQL is a stable browser object. Null only outside a browser (e.g. a test
// env without matchMedia), where the hook reports desktop.
const mql =
  typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia('(max-width: 768px)')
    : null;

function subscribe(onChange: () => void): () => void {
  mql?.addEventListener('change', onChange);
  return () => mql?.removeEventListener('change', onChange);
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, () => mql?.matches ?? false);
}
